<div class="close-cnt cnt-row">
  <div class="filler"></div>
  <close-btn
    data-testid="UpgradeSubscriptionCloseBtn"
    style="margin-top: 10px"
    (click)="onClose()"
  ></close-btn>
  <div [width]="10"></div>
</div>

<div class="cnt-column" style="height: 100%">
  <scrolldiv
    style="flex: 1; width: 100%"
    [scrollerSize]="20"
    [navigatorSize]="14"
    [scrollVerticalIndent]="0"
    cls="lightScroll"
  >
    <div [height]="40"></div>

    <div class="cnt-column" style="align-items: stretch">
      <div class="cnt-column-centered">
        <div #pane class="pane" [height]="height" [width]="width">
          <div [height]="20"></div>
          <div class="b1Color h1Font title">{{ title | translate }}</div>
          <div [height]="14"></div>

          <div class="p1Font b1Color" class="textbox" i18n>
              {{ 'IN_ORDER_FOR_YOU' | translate }}
          </div>

          <div>
            
              <div [height]="20"></div>

              <div class="cnt-column-centered">
                <img-text
                  [hint]="'ENTER_ORGANISATION' | translate"
                  i18n-hint
                  labelClass="lab-sb"
                  name="company"
                  [(ngModel)]="Company.CompanyName"
                  i18n-label
                  [label]="'ORGANISATION_NAME' | translate"
                  [height]="58"
                  [width]="550"
                  [fieldClass]="'large-field'"
                  [maxlen]="200"
                  testId="company"
                ></img-text>
              </div>

              <div [height]="30"></div>
              <div class="bottomline"></div>
              <div [height]="15"></div>

              <simple-btn
                (click)="saveClick()"
                style="margin: auto"
                [width]="230"
                [backgroundFillCls]="'o2Background'"
                [hoverFillCls]="'o1Background'"
                text="{{ companyBtnText | translate }}"
                data-testid="saveBtn"
                [textCls]="'large-btn-text'"
                [height]="40"
                [cornerRadius]="50"
                [horizontalPadding]="20"
              >
              </simple-btn>
            
          </div>
        </div>

        <div [height]="25"></div>
        <div [height]="14"></div>
      </div>
    </div>
  </scrolldiv>
</div>
